import { decodeJwt } from 'jose';
export const isTokenExpired = (token) => {
    const tokenData = token && decodeJwt(token);
    return !tokenData || tokenData.exp < Date.now() / 1000;
};
